module.exports = __webpack_public_path__ + "img/lessoncard-simple-back.c80de4cc.svg";